import axios from "axios";

export class HttpRequestBuilder {
    constructor() {
        this.config = {};
    }

    // Set the request method
    method(method) {
        this.config.method = method;
        return this;
    }

    // Set the request URL
    url(url) {
        this.config.url = url;
        return this;
    }

    // Set the request headers
    headers(headers) {
        this.config.headers = headers;
        return this;
    }

    // Set URL parameters
    params(params) {
        this.config.params = params;
        return this;
    }

    // Set the request body data
    data(data) {
        this.config.data = data;
        return this;
    }

    validateStatus(validateStatus) {
        this.config.validateStatus = validateStatus;
        return this;
    }

    // Execute the request with the current configuration
    send() {
        try {
            return axios(this.config);
        } catch (error) {
            console.log("An error has occured while executing HTTP request: " + error);
            throw error;
        }
    }
}